import React, {ReactNode, FC} from "react";
import CoinInfo from "./CoinInfo";


export interface SectionCoinProps {
  className?: string;
  rightImg?: any;
  heading?: ReactNode;
  subHeading?: string;
  btnText?: string;
  data: any;
}

const SectionCoin:FC<SectionCoinProps> = ({data}) => {
  return (
    <div
      className={`SectionCoin relative`}
      data-nc-id="SectionCoin"
    >
      <div
          className="flex flex-col lg:flex-row space-y-14 lg:space-y-0 lg:space-x-10 items-center relative text-center lg:text-left">
        <div className="w-screen max-w-full xl:max-w-lg space-y-5 lg:space-y-7">
          <h2 className="text-3xl !leading-tight font-semibold text-neutral-900 md:text-4xl xl:text-5xl dark:text-neutral-100">
            <div className="flex space-x-4 ">
              <img src={data?.image?.small} alt={data?.name} height="200" style={{marginBottom: 20}}  />
              <h2 className="text-3xl !leading-tight font-semibold text-neutral-900 md:text-4xl xl:text-5xl dark:text-neutral-100">
                {data?.name}
              </h2>
            </div>
          </h2>
          <span className="block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400">
            The live market price of {data?.name} ({data?.symbol}) today is £ {data?.market_data.current_price["gbp"]} GBP with a 24 hour trading volume of £ {data?.market_data.total_volume["gbp"]} GBP. {data?.name} is {data?.market_data?.price_change_percentage_24h}% in the last 24 hours. The current coin ranking on The CryptoVerse is #{data?.market_cap_rank}, with a live market cap of £ {data?.market_data.market_cap["gbp"]} GBP.
          </span>
        </div>
        <div className="flex-grow p-4 sm:p-8 xl:py-14 md:px-10 bg-white bg-opacity-40 backdrop-filter backdrop-blur-lg shadow-lg rounded-3xl space-y-3 sm:space-y-5 !border-opacity-0 --  nc-dark-box-bg">
          <CoinInfo coin={data?.id} />
        </div>
      </div>
    </div>
  );
};

  export default SectionCoin;
